import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem } from "@mui/material";
import { useFormContext } from "react-hook-form";

import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import useTenant from "../../../../hooks/useTenant";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import useAuth from "../../../../hooks/useAuth";
import CustomSwitch from "../../../../components/CustomSwitch";
import useCafForm from "../../../../hooks/useCafForm";
import CafForm from "../../../caf_form";

const currentTenantPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const currentCafPayload = {
  filters: [
    {
      fieldName: "isCafUsed",
      fieldValue: false,
      op: "eq",
      dataType: "boolean",
      isJoin: false,
    },
    {
      fieldName: "isCafUsed",
      fieldValue: "null",
      op: "is_null",
      dataType: "boolean",
      condition: "or",
      isJoin: false,
    },
    {
      fieldName: "status",
      fieldValue: "AP",
      op: "eq",
      dataType: "string",
      isJoin: false,
    },
  ],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function UserFields(props) {
  const { user } = useAuth();
  console.log(user, "useruseruser");
  const { autoSearchTenant, tenantAutoSearchResults } = useTenant();
  const { autoSearchCafForm, cafFormAutoSearchResults, getCafForm, cafForm, resetCAFForm } =
    useCafForm();
  const { validationFields, hideFields } = props;
  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const [tenantPayload, setTenantPayload] = useState(currentTenantPayload);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [cafOptions, setCafOptions] = useState([]);
  const [cafPayload, setCafPayload] = useState(currentCafPayload);

  const fetchTenants = async () => {
    await autoSearchTenant(tenantPayload);
  };

  useEffect(() => {
    console.log(user, "user.businessType");
    if (
      user &&
      (user.businessType == "SUPER_ADMIN" ||
        user.businessType == "DISTRIBUTOR" ||
        user.businessType == "MULTI_SERVICE_OPERATOR" ||
        user.businessType == "ADMIN")
    ) {
      fetchTenants();
    }
  }, [user, tenantPayload]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (cafFormAutoSearchResults.data.length !== 0) {
      const results = [...cafOptions, ...cafFormAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setCafOptions(filteredResults);
    }
  }, [cafFormAutoSearchResults]);

  const resetCAFFields = () => {
    setValue("caf", null);
    setCafOptions([]);
    resetCAFDetails1();
  };

  const tenant = watch("tenant");
  const fetchCAF = async () => {
    if (!tenant || Object.keys(tenant).length === 0) {
      return; // ❌ no reset here
    }

    const updatedPayload = {
      ...cafPayload,
      filters: [
        ...cafPayload.filters.filter((f) => f.fieldName !== "tenantId"),
        {
          fieldName: "tenantId",
          fieldValue: tenant.value,
          op: "eq",
          dataType: "int",
          isJoin: true,
        },
      ],
    };

    setCafPayload(updatedPayload);
    await autoSearchCafForm(updatedPayload);
  };

  useEffect(() => {
    fetchCAF();
  }, [tenant]);

  const accountType = watch("accountType");
  const isCAFLinked = watch("isCafLinked");
  const caf = watch("caf");
  const [userNameDisabled, setUserNameDisabled] = useState(false);
  const [fullNameDisabled, setFullNameDisabled] = useState(false);
  const [connectionTypeDisabled, setConnectionTypeDisabled] = useState(false);
  const [mobileNoDisabled, setMobileNoDisabled] = useState(false);
  const [emailIdDisabled, setEmailIdDisabled] = useState(false);

  const fetchCAFDetails = async () => {
    console.log(caf, "cafcafcaf");
    if (caf != null && Object.keys(caf).length !== 0) {
      await getCafForm(caf?.value);
    }
  };

  useEffect(() => {
    fetchCAFDetails();
  }, [caf]);

  const resetCAFDetails = () => {
    setUserNameDisabled(false);
    setFullNameDisabled(false);
    setConnectionTypeDisabled(false);
    setMobileNoDisabled(false);
    setEmailIdDisabled(false);
    setValue("userName", "");
    setValue("fullName", "");
    setValue("mobileNo", "");
    setValue("emailId", "");
    setValue("connectionType", "");
    setValue("doorNo", "");
    setValue("pinCode", null);
    setValue("area", "");
    setValue("city", "");
    setValue("state", "");
    setValue("country", "");
    setValue("plan", null);

    setValue("insDoorNo", "");
    setValue("insPinCode", null);
    setValue("insArea", "");
    setValue("insCity", "");
    setValue("insState", "");
    setValue("insCountry", "");
  };

  useEffect(() => {
    if (cafForm != null && Object.keys(cafForm).length !== 0) {
      setValue("userName", cafForm?.userName);
      setValue("fullName", cafForm?.fullName);
      setValue("mobileNo", cafForm?.mobileNo);
      setValue("emailId", cafForm?.emailId);
      setValue("connectionType", cafForm?.connectionType);
      setValue("doorNo", cafForm?.doorNo);
      setValue("pinCode", {
        label: cafForm?.pinCode,
        value: cafForm?.pinCode,
      });
      setValue("area", cafForm?.area);
      setValue("city", cafForm?.city);
      setValue("state", cafForm?.state);
      setValue("country", cafForm?.country);
      setValue("plan", {
        label: cafForm?.planName,
        value: cafForm?.planId,
      });

      setValue("insDoorNo", cafForm?.insDoorNo);
      setValue("insPinCode", {
        label: cafForm?.insPinCode,
        value: cafForm?.insPinCode,
      });
      setValue("insArea", cafForm?.insArea);
      setValue("insCity", cafForm?.insCity);
      setValue("insState", cafForm?.insState);
      setValue("insCountry", cafForm?.insCountry);

      setUserNameDisabled(true);
      setFullNameDisabled(true);
      setConnectionTypeDisabled(true);
      setMobileNoDisabled(true);
      setEmailIdDisabled(true);
    }
  }, [cafForm]);

  const resetCAFDetails1 = async () => {
    await resetCAFForm();
  };

  const changeTenantEvent = (name, value) => {
    setValue(name, value); // set tenant first
    resetCAFFields(); // only CAF-related reset
  };

  const changeCAFEvent = (name, value) => {
    if (value == null) {
      resetCAFDetails();
      resetCAFDetails1();
    }

    setValue(name, value);
  };

  const cafLinkedChange = (value) => {
    if (!value) {
      resetCAFFields();
      resetCAFDetails();
    }
  };

  return (
    <Grid container spacing={12} className="row" pt={8}>
      {user &&
        (user.businessType === "SUPER_ADMIN" ||
          user.businessType == "DISTRIBUTOR" ||
          user.businessType == "MULTI_SERVICE_OPERATOR" ||
          user.businessType == "ADMIN" ||
          user.businessType == "DOT") && (
          <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
            <SearchableAutoComplete
              control={control}
              data={tenantOptions}
              label={t("select_franchise")}
              payload={tenantPayload}
              setPayload={setTenantPayload}
              loading={false}
              name="tenant"
              multiple={false}
              defaultValue={""}
              hasNextPage={false}
              fields={validationFields}
              onChangeEvent={changeTenantEvent}
            />
          </Grid>
        )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomSwitch
          label={t("is_caf_linked")}
          name="isCafLinked"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          onChange={cafLinkedChange}
        />
      </Grid>
      {isCAFLinked && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <SearchableAutoComplete
            control={control}
            data={cafOptions}
            label={t("select_caf")}
            payload={cafPayload}
            setPayload={setCafPayload}
            loading={false}
            name="caf"
            multiple={false}
            defaultValue={""}
            hasNextPage={false}
            fields={validationFields}
            onChangeEvent={changeCAFEvent}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("accountType") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <ReactHookFormSelect
            name="accountType"
            label={t("account_type")}
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          >
            <MenuItem value={"NORMAL_USER"}>Normal User</MenuItem>
            <MenuItem value={"MAC_USER"}>MAC User</MenuItem>
          </ReactHookFormSelect>
        </Grid>
      )}
      {hideFields && !hideFields.includes("userName") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("user_name")}
            name="userName"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
            disabled={userNameDisabled}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("mac") && accountType && accountType == "MAC_USER" && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("mac")}
            name="mac"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("routerPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("router_password")}
            name="routerPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("confirmRouterPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("confirm_router_password")}
            name="confirmRouterPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("appPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("app_password")}
            name="appPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("confirmAppPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("confirm_app_password")}
            name="confirmAppPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Full Name")}
          name="fullName"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={fullNameDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Mobile Number")}
          name="mobileNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={mobileNoDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Email Id")}
          name="emailId"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={emailIdDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("GST No")}
          name="gstNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="userServiceType"
          label={t("user_service_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        >
          <MenuItem value={"INTERNET"}>Internet</MenuItem>
          <MenuItem value={"COMBO"}>Combo</MenuItem>
          <MenuItem value={"INTERNET_OTT"}>Internet & OTT</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="connectionType"
          label={t("connection_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={connectionTypeDisabled}
        >
          <MenuItem value={"HOME_USER"}>Home User</MenuItem>
          <MenuItem value={"BUSINESS_USER"}>Business User</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="status"
          label={t("Status")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        >
          <MenuItem value={"ACTIVE"}>ACTIVE</MenuItem>
          <MenuItem value={"INACTIVE"}>INACTIVE</MenuItem>
        </ReactHookFormSelect>
      </Grid>
    </Grid>
  );
}

export default UserFields;
